export class Bill {
  billTitle = '';
  billAmount = 0;
  decimalBillAmount = 0;
  taxAmount = '';
  billDate: Date | undefined;
  dueDate: Date | undefined;
  balanceTitle = '';
  dueDateTitle = '';
  billDateTitle = '';
}

export class BurialStatus {
  statusValue = '';
  statusState = '';
}

export enum statusStateEnum {
  COMPLETED = 'COMPLETED',
  CLOSED = 'CLOSED',
  CLOSED_COMPLETE = 'CLOSED_COMPLETE',
  INPROGRESS = 'INPROGRESS',
}

export enum stageEnum {
  CURRENT = 'CURRENT STATUS:',
  PREVIOUS = 'PREVIOUS STAGE',
  FUTURE = 'FUTURE STAGE',
}

export enum StatusLabel {
  SUCCESS = 'SUCCESS',
  PENDING = 'PENDING',
  FAILED = 'FAILED',
}

export interface StatusSummary {
  header: string;
  statusLabel?: StatusLabel;
  viewDetailsLinkText: string;
  statusDetails: StatusDetails;
}

export interface StatusDetails {
  header: string;
  statusItemList?: StatusItem[];
  statusDetailsActions?: StatusDetailsActions;
}

export interface StatusItem {
  header: string;
  statusLabel?: StatusLabel;
  description?: string;
}

export interface StatusDetailsActions {
  header: string;
  okBtnText: string;
  cancelBtnText: string;
}

export interface EmailInputField {
  label: string;
  placeholder: string;
  value?: string;
}
